import Vue from 'vue'
import Router from 'vue-router'
import { db, auth } from '@/firebase'
import Login from '@/views/login.vue'
import Dashboard from '@/views/dashboard.vue'
//Vistas Clientes
import Clientes from '@/views/clientes.vue'
import Cliente from '@/views/cliente.vue'
//Vistas Servicios
import Servicios from '@/views/servicios.vue'
import Servicio from '@/views/servicio.vue'
//Vistas Productos
import Productos from '@/views/productos.vue'
import Producto from '@/views/producto.vue'
//Vistas Cotizaciones
import Cotizaciones from '@/views/cotizaciones.vue'
import Versiones from '@/views/versiones.vue'
import crearCotizacion from '@/views/crear-cotizacion.vue'
import crearVersion from '@/views/crear-version.vue'
import editarVersion from '@/views/editar-version.vue'

Vue.use(Router)

const router = new Router({
  //base: '/app', 
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/dashboard'
    },
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/dashboard',
      name: 'Resumen',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [
          {url: '/cotizacion', titulo: 'Agregar Cotización'},
          {url: '/cliente', titulo: 'Agregar Cliente'},
          {url: '/servicio', titulo: 'Agregar Servicio'},
          {url: '/producto', titulo: 'Agregar Producto'}
        ]
      }
    },
    {
      path: '/clientes',
      name: 'Clientes',
      component: Clientes,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [
          {url: '/cliente', titulo: 'Agregar Cliente'}
        ],
        back_link: '/dashboard'
      }
    },
    {
      path: '/cliente',
      name: 'Crear Cliente',
      component: Cliente,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/clientes'
      }
    },
    {
      path: '/cliente/:id',
      name: 'Editar Cliente',
      component: Cliente,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/clientes'
      }
    },
    {
      path: '/servicios',
      name: 'Servicios',
      component: Servicios,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [
          {url: '/servicio', titulo: 'Agregar Servicio'}
        ],
        back_link: '/dashboard'
      }
    },
    {
      path: '/servicio',
      name: 'Crear Servicio',
      component: Servicio,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/servicios'
      }
    },
    {
      path: '/servicio/:id',
      name: 'Editar Servicio',
      component: Servicio,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/servicios'
      }
    },
    {
      path: '/productos',
      name: 'Productos',
      component: Productos,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [
          {url: '/producto', titulo: 'Agregar Producto'}
        ],
        back_link: '/dashboard'
      }
    },
    {
      path: '/producto',
      name: 'Crear Producto',
      component: Producto,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/productos'
      }
    },
    {
      path: '/producto/:id',
      name: 'Editar Producto',
      component: Producto,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/productos'
      }
    },
    {
      path: '/cotizaciones',
      name: 'Cotizaciones',
      component: Cotizaciones,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [
          {url: '/cotizacion', titulo: 'Agregar Cotización'}
        ],
        back_link: '/dashboard'
      }
    },
    {
      path: '/cotizacion/:id',
      name: 'Versiones Cotización',
      component: Versiones,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/cotizaciones'
      }
    },
    {
      path: '/cotizacion/:id/:version',
      name: 'Versión Cotización',
      component: Versiones,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/cotizaciones'
      }
    },
    {
      path: '/cotizacion/',
      name: 'Crear Cotización',
      component: crearCotizacion,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/cotizaciones'
      }
    },
    {
      path: '/version/:id',
      name: 'Crear Versión',
      component: crearVersion,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/cotizacion/:id'
      }
    },
    {
      path: '/version/:id/:version',
      name: 'Editar Versión',
      component: editarVersion,
      meta: {
        requiresAuth: true,
        header_style: '',
        short_links: [],
        back_link: '/cotizacion/:id'
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    var elmnt = document.getElementById('wallet-application')
    elmnt.scrollTo(0, 0)
  }
})

router.beforeEach((to, from, next) => {
  document.title = 'Fottom Flux - ' + to.name
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const currentUser = auth.currentUser
  if (requiresAuth && !currentUser) {
    next('/')
  } else if (!requiresAuth && currentUser) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router